import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _7e3cdac2 = () => interopDefault(import('../pages/aanmelden.vue' /* webpackChunkName: "pages/aanmelden" */))
const _763aef44 = () => interopDefault(import('../pages/categorieen/index.vue' /* webpackChunkName: "pages/categorieen/index" */))
const _a01907a8 = () => interopDefault(import('../pages/gratis-sexfilms/index.vue' /* webpackChunkName: "pages/gratis-sexfilms/index" */))
const _1737e024 = () => interopDefault(import('../pages/modellen/index.vue' /* webpackChunkName: "pages/modellen/index" */))
const _cefc69c2 = () => interopDefault(import('../pages/nieuws/index.vue' /* webpackChunkName: "pages/nieuws/index" */))
const _338e83bc = () => interopDefault(import('../pages/onbeperkt/index.vue' /* webpackChunkName: "pages/onbeperkt/index" */))
const _05ac8c61 = () => interopDefault(import('../pages/sexfilms/index.vue' /* webpackChunkName: "pages/sexfilms/index" */))
const _8515f94a = () => interopDefault(import('../pages/transactie.vue' /* webpackChunkName: "pages/transactie" */))
const _f373bc6e = () => interopDefault(import('../pages/webcamsex/index.vue' /* webpackChunkName: "pages/webcamsex/index" */))
const _261be0ac = () => interopDefault(import('../pages/zoekresultaten/index.vue' /* webpackChunkName: "pages/zoekresultaten/index" */))
const _5f39875c = () => interopDefault(import('../pages/account/gegevens-voorkeuren.vue' /* webpackChunkName: "pages/account/gegevens-voorkeuren" */))
const _2cc94e96 = () => interopDefault(import('../pages/account/gehuurd.vue' /* webpackChunkName: "pages/account/gehuurd" */))
const _04a4ffb0 = () => interopDefault(import('../pages/account/inloggen.vue' /* webpackChunkName: "pages/account/inloggen" */))
const _4f51b938 = () => interopDefault(import('../pages/account/mijn-credits.vue' /* webpackChunkName: "pages/account/mijn-credits" */))
const _5eb0c0a9 = () => interopDefault(import('../pages/account/mijn-favorieten.vue' /* webpackChunkName: "pages/account/mijn-favorieten" */))
const _0839037d = () => interopDefault(import('../pages/account/onbeperkt.vue' /* webpackChunkName: "pages/account/onbeperkt" */))
const _555401eb = () => interopDefault(import('../pages/account/registreren.vue' /* webpackChunkName: "pages/account/registreren" */))
const _045ea1da = () => interopDefault(import('../pages/account/wachtwoord-herstellen.vue' /* webpackChunkName: "pages/account/wachtwoord-herstellen" */))
const _207df57e = () => interopDefault(import('../pages/account/wachtwoord-vergeten.vue' /* webpackChunkName: "pages/account/wachtwoord-vergeten" */))
const _a140bc30 = () => interopDefault(import('../pages/betalen/direct.vue' /* webpackChunkName: "pages/betalen/direct" */))
const _4a2a5861 = () => interopDefault(import('../pages/betalen/huurtegoed.vue' /* webpackChunkName: "pages/betalen/huurtegoed" */))
const _b13161c6 = () => interopDefault(import('../pages/info/algemene-voorwaarden.vue' /* webpackChunkName: "pages/info/algemene-voorwaarden" */))
const _233d9357 = () => interopDefault(import('../pages/info/contact/index.vue' /* webpackChunkName: "pages/info/contact/index" */))
const _72707878 = () => interopDefault(import('../pages/info/feedback/index.vue' /* webpackChunkName: "pages/info/feedback/index" */))
const _b49d1aec = () => interopDefault(import('../pages/info/nieuwsbrief/index.vue' /* webpackChunkName: "pages/info/nieuwsbrief/index" */))
const _416465d0 = () => interopDefault(import('../pages/info/over.vue' /* webpackChunkName: "pages/info/over" */))
const _3f677188 = () => interopDefault(import('../pages/info/privacy.vue' /* webpackChunkName: "pages/info/privacy" */))
const _216b0d2b = () => interopDefault(import('../pages/info/sex-link-partners.vue' /* webpackChunkName: "pages/info/sex-link-partners" */))
const _b0cc023a = () => interopDefault(import('../pages/info/uitschrijven/index.vue' /* webpackChunkName: "pages/info/uitschrijven/index" */))
const _30afe6cf = () => interopDefault(import('../pages/info/veelgestelde-vragen.vue' /* webpackChunkName: "pages/info/veelgestelde-vragen" */))
const _58a8af1c = () => interopDefault(import('../pages/info/contact/bedankt.vue' /* webpackChunkName: "pages/info/contact/bedankt" */))
const _42687849 = () => interopDefault(import('../pages/info/feedback/bedankt.vue' /* webpackChunkName: "pages/info/feedback/bedankt" */))
const _0da18d8f = () => interopDefault(import('../pages/info/nieuwsbrief/bedankt.vue' /* webpackChunkName: "pages/info/nieuwsbrief/bedankt" */))
const _bf613d42 = () => interopDefault(import('../pages/info/nieuwsbrief/uitschrijven/index.vue' /* webpackChunkName: "pages/info/nieuwsbrief/uitschrijven/index" */))
const _bd48987a = () => interopDefault(import('../pages/info/uitschrijven/uitgeschreven.vue' /* webpackChunkName: "pages/info/uitschrijven/uitgeschreven" */))
const _18b4da3f = () => interopDefault(import('../pages/info/nieuwsbrief/uitschrijven/uitgeschreven.vue' /* webpackChunkName: "pages/info/nieuwsbrief/uitschrijven/uitgeschreven" */))
const _1fe24c0d = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _79a831d4 = () => interopDefault(import('../pages/categorieen/_slug.vue' /* webpackChunkName: "pages/categorieen/_slug" */))
const _a3864a38 = () => interopDefault(import('../pages/gratis-sexfilms/_slug.vue' /* webpackChunkName: "pages/gratis-sexfilms/_slug" */))
const _15813edc = () => interopDefault(import('../pages/modellen/_slug.vue' /* webpackChunkName: "pages/modellen/_slug" */))
const _d269ac52 = () => interopDefault(import('../pages/nieuws/_slug.vue' /* webpackChunkName: "pages/nieuws/_slug" */))
const _03f5eb19 = () => interopDefault(import('../pages/sexfilms/_slug.vue' /* webpackChunkName: "pages/sexfilms/_slug" */))
const _76bfe244 = () => interopDefault(import('../pages/webcamsex/_slug/index.vue' /* webpackChunkName: "pages/webcamsex/_slug/index" */))
const _7297ea6a = () => interopDefault(import('../pages/webcamsex/_slug/live.vue' /* webpackChunkName: "pages/webcamsex/_slug/live" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/aanmelden",
    component: _7e3cdac2,
    name: "aanmelden"
  }, {
    path: "/categorieen",
    component: _763aef44,
    name: "categorieen"
  }, {
    path: "/gratis-sexfilms",
    component: _a01907a8,
    name: "gratis-sexfilms"
  }, {
    path: "/modellen",
    component: _1737e024,
    name: "modellen"
  }, {
    path: "/nieuws",
    component: _cefc69c2,
    name: "nieuws"
  }, {
    path: "/onbeperkt",
    component: _338e83bc,
    name: "onbeperkt"
  }, {
    path: "/sexfilms",
    component: _05ac8c61,
    name: "sexfilms"
  }, {
    path: "/transactie",
    component: _8515f94a,
    name: "transactie"
  }, {
    path: "/webcamsex",
    component: _f373bc6e,
    name: "webcamsex"
  }, {
    path: "/zoekresultaten",
    component: _261be0ac,
    name: "zoekresultaten"
  }, {
    path: "/account/gegevens-voorkeuren",
    component: _5f39875c,
    name: "Gegevens & voorkeuren"
  }, {
    path: "/account/gehuurd",
    component: _2cc94e96,
    name: "Gehuurd"
  }, {
    path: "/account/inloggen",
    component: _04a4ffb0,
    name: "account-inloggen"
  }, {
    path: "/account/mijn-credits",
    component: _4f51b938,
    name: "Mijn credits"
  }, {
    path: "/account/mijn-favorieten",
    component: _5eb0c0a9,
    name: "Mijn favorieten"
  }, {
    path: "/account/onbeperkt",
    component: _0839037d,
    name: "Direct"
  }, {
    path: "/account/registreren",
    component: _555401eb,
    name: "account-registreren"
  }, {
    path: "/account/wachtwoord-herstellen",
    component: _045ea1da,
    name: "account-wachtwoord-herstellen"
  }, {
    path: "/account/wachtwoord-vergeten",
    component: _207df57e,
    name: "account-wachtwoord-vergeten"
  }, {
    path: "/betalen/direct",
    component: _a140bc30,
    name: "betalen-direct"
  }, {
    path: "/betalen/huurtegoed",
    component: _4a2a5861,
    name: "betalen-huurtegoed"
  }, {
    path: "/info/algemene-voorwaarden",
    component: _b13161c6,
    name: "info-algemene-voorwaarden"
  }, {
    path: "/info/contact",
    component: _233d9357,
    name: "info-contact"
  }, {
    path: "/info/feedback",
    component: _72707878,
    name: "info-feedback"
  }, {
    path: "/info/nieuwsbrief",
    component: _b49d1aec,
    name: "info-nieuwsbrief"
  }, {
    path: "/info/over",
    component: _416465d0,
    name: "info-over"
  }, {
    path: "/info/privacy",
    component: _3f677188,
    name: "info-privacy"
  }, {
    path: "/info/sex-link-partners",
    component: _216b0d2b,
    name: "info-sex-link-partners"
  }, {
    path: "/info/uitschrijven",
    component: _b0cc023a,
    name: "info-uitschrijven"
  }, {
    path: "/info/veelgestelde-vragen",
    component: _30afe6cf,
    name: "info-veelgestelde-vragen"
  }, {
    path: "/info/contact/bedankt",
    component: _58a8af1c,
    name: "info-contact-bedankt"
  }, {
    path: "/info/feedback/bedankt",
    component: _42687849,
    name: "info-feedback-bedankt"
  }, {
    path: "/info/nieuwsbrief/bedankt",
    component: _0da18d8f,
    name: "info-nieuwsbrief-bedankt"
  }, {
    path: "/info/nieuwsbrief/uitschrijven",
    component: _bf613d42,
    name: "info-nieuwsbrief-uitschrijven"
  }, {
    path: "/info/uitschrijven/uitgeschreven",
    component: _bd48987a,
    name: "info-uitschrijven-uitgeschreven"
  }, {
    path: "/info/nieuwsbrief/uitschrijven/uitgeschreven",
    component: _18b4da3f,
    name: "info-nieuwsbrief-uitschrijven-uitgeschreven"
  }, {
    path: "/",
    component: _1fe24c0d,
    name: "index"
  }, {
    path: "/categorieen/:slug",
    component: _79a831d4,
    name: "categorieen-slug"
  }, {
    path: "/gratis-sexfilms/:slug?",
    component: _a3864a38,
    name: "gratis-sexfilms-slug"
  }, {
    path: "/modellen/:slug",
    component: _15813edc,
    name: "modellen-slug"
  }, {
    path: "/nieuws/:slug",
    component: _d269ac52,
    name: "nieuws-slug"
  }, {
    path: "/sexfilms/:slug",
    component: _03f5eb19,
    name: "sexfilms-slug"
  }, {
    path: "/webcamsex/:slug",
    component: _76bfe244,
    name: "webcamsex-slug"
  }, {
    path: "/webcamsex/:slug/live",
    component: _7297ea6a,
    name: "webcamsex-slug-live"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
